
class mrkVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateURL();
    this.updateVariantStatuses();
    if (this.currentVariant) {
      this.updateVariantInput();
    }
    this.updateData();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    console.log(this.currentVariant.id);
    const selectBtn= document.querySelector('#variant-selector');
    for (let option of selectBtn.options) {
        if (Number(option.value) ==  this.currentVariant.id) {
            console.log(this.currentVariant,option.value);
            option.selected = true;
            break;
        }
    }
    const changeEvent = new Event('change', {
        'bubbles': true,
        'cancelable': true
    });
    selectBtn.dispatchEvent(changeEvent);
  }
   updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }
  updateData(){
    const cartAddBtn = document.querySelector('.atc-button')
    const productComparePrice = document.querySelector('.sale-price')
    const productPrice = document.querySelector('.product-price')


    const addProductToCart = (id) => {
      window.cartHandler.addCartItem(id).then(window.cartHandler.openCart)
    }
    const selectElement = document.querySelector('#variant-selector');
    
    var activeVariant = selectElement.options[selectElement.selectedIndex];
    const activeVariantImagePath = location.protocol + activeVariant.dataset.imageSrc.substring(0, activeVariant.dataset.imageSrc.indexOf('?'));

    if (window.innerWidth <= 1000) {
      const swiperMedia = [...document.querySelectorAll('[data-swiper-media]')]
      swiperMedia.forEach(media => {
        const mediaPath = media.src.substring(0, media.src.indexOf('?'));
        if (mediaPath === activeVariantImagePath) {
          productImageSwiper.slideTo(+media.dataset.position, false, false)
        }
      })
    }else{
      const scrollerMedia = [...document.querySelectorAll('[data-scroller-media]')]
      scrollerMedia.forEach(mediaContainer => {
        const media = mediaContainer.firstElementChild
        const mediaPath = media.src.substring(0, media.src.indexOf('?'));
        if (mediaPath === activeVariantImagePath) {
          setTimeout(function(){
            mediaScrollTo(+media.dataset.mediaIndex, mediaContainer)
          }, 1000)
          
        }
      })
    }
    var productVariantsContainer = document.getElementById('product-variants')
    var productVariants = [...document.querySelectorAll('#variant-selector option')]

    if(productVariants.length < 2) {
      productVariantsContainer.classList.add('d-none')
    }

      const handleATCButton = () => {
      const isOutOfStock = activeVariant ? activeVariant.classList.contains('disabled') : false

      cartAddBtn.innerText = ''
      cartAddBtn.id = ''
      cartAddBtn.onclick = ''
      if('{{ product.metafields.accentuate.contact_for_pricing_enabled }}' === 'true') {
        cartAddBtn.innerText = 'Contact for pricing'
        cartAddBtn.onclick = (e) => {
          e.preventDefault()
          let selectedVariant = document.getElementsByClassName(
            'product-variant active'
          )[0]
          toggleCFPModal(selectedVariant.dataset.variant, selectedVariant.dataset.variantTitle, selectedVariant.dataset.imageSrc)
        }

        return
      } else if(isOutOfStock) {
        cartAddBtn.innerText = activeVariant.dataset.price + ' | Notify Me When Back in Stock'
        cartAddBtn.onclick = (e) => {
          e.preventDefault()
        
          window.BISModal.openBISModal(activeVariant.dataset.variant, activeVariant.dataset.productId)
        }
        return
      }
      cartAddBtn.innerText = activeVariant.dataset.price + " | ADD TO CART"
      productComparePrice.innerText = activeVariant.dataset.compareprice
      productPrice.innerText = activeVariant.dataset.price

      cartAddBtn.onclick = function (e){
      e.preventDefault()
      cartAddBtn.classList.add('loading')
      cartAddBtn.blur()
      cartAddBtn.disabled = true
      // addProductToCart(activeVariant.dataset.variant)
      window.cartHandler.addCartItem(activeVariant.dataset.variant).then(window.cartHandler.openCart)
      .finally(() => {
        cartAddBtn.classList.remove('loading')
        cartAddBtn.disabled = false
      })  
    }
    } 
    
    handleATCButton()

    productVariants.forEach((variant) => {
      variant.addEventListener('click', function () {

        if (variant === activeVariant) return

        activeVariant.classList.remove('active')
        variant.classList.add('active')
        variantSelectorEl.value = variant.dataset.variant
        activeVariant = variant
        handleATCButton()
        //cartAddBtn.innerText = variant.dataset.price  + " | ADD TO CART"
        isOutOfStock = activeVariant ? activeVariant.classList.contains('disabled') : false
        if (isOutOfStock) {
        cartAddBtn.innerText = variant.dataset.price  + ' | Notify Me When Back in Stock'
        }
        
        //productComparePrice.innerText = variant.dataset.compareatprice
        const variantImagePath = 'https:' + variant.dataset.imageSrc.substring(0, variant.dataset.imageSrc.indexOf('?'));
        if (window.innerWidth <= 1000) {
          const swiperMedia = [...document.querySelectorAll('[data-swiper-media]')]
          swiperMedia.forEach(media => {
            const mediaPath = media.src.substring(0, media.src.indexOf('?'));
            if (mediaPath === variantImagePath) {
              productImageSwiper.slideTo(+media.dataset.position, false, false)
            }
          })
        } else if (document.readyState === 'complete') {
          const scrollerMedia = [...document.querySelectorAll('[data-scroller-media]')]
          scrollerMedia.forEach(mediaContainer => {
            const media = mediaContainer.firstElementChild
            const mediaPath = media.src.substring(0, media.src.indexOf('?'));
            if (mediaPath === variantImagePath) {
              mediaScrollTo(+media.dataset.mediaIndex, mediaContainer)
            }
          })
        }
      })
    })
  }
}

customElements.define('mrk-variant-selects', mrkVariantSelects);

class mrkVariantRadios extends mrkVariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('mrk-variant-radios', mrkVariantRadios);
document.querySelector('mrk-variant-radios').dispatchEvent(new Event('change', { bubbles: true }))